import AuthService from "services/auth";
import GridPage from "components/layout/GridPage";
import useIsMobile from "components/hooks/useIsMobile";
import DocumentPage from "components/documents/DocumentPage";
import PublicDocumentWrapper from "components/documents/PublicDocumentWrapper";

export default () => {
  const currentUser = AuthService.getCurrentUser();
  const isMobile = useIsMobile();

  return currentUser ? (
    <GridPage
      sx={{
        maxWidth: "1000px",
        margin: isMobile ? "" : "auto",
        gap: "20px",
        padding: isMobile ? "0" : undefined,
        paddingBottom: "0px",
      }}
    >
      <DocumentPage isMemberDocument={true} showFullActions={false} />
    </GridPage>
  ) : (
    <PublicDocumentWrapper />
  );
};
